import React, { FC } from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { IngredientForm } from './ingredient-form';
import { useTranslate } from '@refinedev/core';

import styles from './compositions.module.scss';
import { buildKey } from '../../../../utils/accessory';
import { ICategory } from '../../../../interfaces';
import { Button, Col, Divider, Form, Row } from 'antd';
import { useSelect } from '@refinedev/antd';
import { FormItem, Input, Select, Textarea, SelectProps } from 'components/ui';

const FIELD_KEY = 'compositions';

interface ICompositionsProps {}

export const generateId = (initialValue?: number, count?: number) => {
    return initialValue! + count!;
};

export const Compositions: FC<ICompositionsProps> = () => {
    const t = useTranslate();

    const { selectProps: doseForm } = useSelect<ICategory>({
        resource: 'dictionary/pharmaceutical-forms',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    }) as {
        selectProps: SelectProps<ICategory>;
    };

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} md={24} style={{ marginTop: 9, marginBottom: 9 }}>
                <Form.List name={FIELD_KEY}>
                    {(fields, { add, remove }, { errors }) => {
                        return (
                            <div>
                                {fields?.length > 0 && (
                                    <Divider>
                                        {t(
                                            'applications.fields.drug_formulations'
                                        )}
                                    </Divider>
                                )}
                                {fields.map((field, index) => (
                                    <div
                                        className={styles.holder}
                                        key={buildKey(FIELD_KEY, ++field.key)}
                                    >
                                        <Row gutter={[16, 16]}>
                                            <Col span={24}>
                                                <FormItem
                                                    {...field}
                                                    name={[
                                                        field.name,
                                                        'number',
                                                    ]}
                                                    initialValue={generateId(
                                                        100,
                                                        index
                                                    )}
                                                >
                                                    <Input
                                                        disabled
                                                        label={t(
                                                            'applications.fields.number_formulations'
                                                        )}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    {...field}
                                                    name={[
                                                        field.name,
                                                        'doseFormId',
                                                    ]}
                                                >
                                                    <Select
                                                        {...doseForm}
                                                        label={t(
                                                            'applications.fields.pharmaceutical_form'
                                                        )}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    {...field}
                                                    name={[
                                                        field.name,
                                                        'description',
                                                    ]}
                                                >
                                                    <Textarea
                                                        label={t(
                                                            'applications.fields.description'
                                                        )}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <Row
                                                    justify="end"
                                                    gutter={[16, 16]}
                                                >
                                                    <Col>
                                                        <Button
                                                            type="text"
                                                            danger
                                                            icon={
                                                                <MinusCircleOutlined />
                                                            }
                                                            onClick={() =>
                                                                remove(
                                                                    field.name
                                                                )
                                                            }
                                                            aria-label={t(
                                                                'buttons.delete'
                                                            )}
                                                        >
                                                            {t(
                                                                'buttons.delete'
                                                            )}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <div className={styles.ingredientsRow}>
                                            <IngredientForm
                                                fieldKey={field.name}
                                            />
                                        </div>
                                    </div>
                                ))}
                                {fields?.length > 0 && (
                                    <Divider style={{ margin: '16px 0' }} />
                                )}
                                <Button
                                    type="dashed"
                                    onClick={() => {
                                        add({}, fields?.length);
                                    }}
                                    block
                                    style={{ marginBottom: 20 }}
                                >
                                    <PlusOutlined />
                                    {t('applications.fields.add_composition')}
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </div>
                        );
                    }}
                </Form.List>
            </Col>
        </Row>
    );
};
